import gql from 'graphql-tag';

export default gql`
  query ShortedOrderLines($orderId: Int!) {
    shortedOrderLines(orderId: $orderId) {
      skOrderLineId
      offeringNum
      custRef
      description
      qtyRequested
      qtyShort
      caseQty
      displaySuffix
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/getShortedOrderLines.js